<template>
  <div id="app">
    <vue-header v-if="$route.name !== 'Raffle'"></vue-header>
    <router-view class="main"></router-view>
    <!-- <vue-footer></vue-footer> -->
  </div>
</template>

<script>
import VueHeader from './components/header.vue'
// import VueFooter from "./include/vueFooter.vue";

export default {
  components: {
    // VueFooter,
    VueHeader
  },
  name: 'app',
  data: function() {
    return {
      showHeader: true
    }
  },
  watch: {
    '$route.meta.title': {
      handler: function(v) {
        document.title = `${v} - ${this.$store.state.site.info.page}`
      },
      deep: true
    },
    '$store.state.user.info': {
      handler: function(v) {
        // console.log(v, this.$route.fullPath)
        if (!v) this.$router.push({ path: '/login', query: { redirect: this.$route.fullPath } })
      },
      deep: true
    }
  },
  mounted: function() {
    document.title = `${this.$route.meta.title} - ${this.$store.state.site.info.page}`
    this.$nextTick(function() {})
  }
}
</script>

<style>
/*@import url("/css/style.css");*/
* {
  margin: 0;
  padding: 0;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,
    sans-serif;
}

body {
  padding: 0 20px;
}

br {
  clear: both;
  height: 0;
  font-size: 0;
  line-height: 0;
}

div.main {
  max-width: 1200px;
  margin: auto;
}

.el-col {
  margin-bottom: 20px;
}

.el-table .error-row {
  background: rgb(255, 235, 235);
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
